/* global gtag */
const GA = {
	TrackPageView(href) {
		if (typeof window.dataLayer !== 'undefined') {
			try {
				window.dataLayer.push({
					event: 'VirtualPageView',
					page_path: href
				});
			} catch (e) {
				// continue regardless of error
			}
		}
	},
	TrackEvent(category, action, label, value) {
		if (typeof window.dataLayer !== 'undefined') {
			try {
				window.dataLayer.push({
					event: 'Event',
					category,
					action,
					label,
					value
				});
			} catch (e) {
				// continue regardless of error
			}
		}
	}
};

export default GA;
